import * as yup from 'yup';
import { emailField, TranslateFn } from '../../library/validationRules';
import ResourcesIds from '../../resources/ResourcesIds';

/**
 * The only place `allowAdminHandle` is passed. "admin" is a sign-in handle rather than a
 * mailbox, so it belongs here and nowhere an invitation is addressed.
 */
export const createLoginSchema = (translate: TranslateFn) => yup.object({
    emailAddress: emailField(translate, { allowAdminHandle: true }),
    password: yup.string().required(translate(ResourcesIds.PASSWORD_REQUIRED)),
});
